import { X } from "lucide-react";
import { useLocale, useT } from "../../i18n";
import { formatPriceShort } from "../../lib/format";
import { labelOf, useTaxonomies } from "../../lib/taxonomies";

const LISTS = { body_type: "body_types", fuel: "fuel_types", transmission: "transmissions", drivetrain: "drivetrains",
  aspiration: "aspirations", exterior_color: "colors", equipment: "equipment" };
const RANGES = [["year_from", "year_to", "filters.year", (v) => v], ["price_min", "price_max", "filters.price", "price"],
  ["mileage_min", "mileage_max", "filters.mileage", (v) => `${(+v).toLocaleString("en-US")} km`],
  ["displacement_min", "displacement_max", "filters.displacement", (v) => `${(+v).toLocaleString("en-US")} cc`]];

// Removable chips for every active filter (each chip removes just its own value).
export const FilterChips = ({ filters, update, facets }) => {
  const t = useT();
  const lang = useLocale();
  const [tx] = useTaxonomies();
  const chips = [];
  const make = facets?.makes?.find((m) => m.value === filters.make);
  if (filters.make) chips.push(["make", make?.label || filters.make, { make: "", model: "" }]);
  if (filters.model) chips.push(["model", make?.models.find((m) => m.value === filters.model)?.label || filters.model, { model: "" }]);
  RANGES.forEach(([a, b, label, f]) => {
    if (!filters[a] && !filters[b]) return;
    const show = f === "price" ? (v) => formatPriceShort(+v, lang) : f;
    chips.push([a, `${t(label)} ${filters[a] ? show(filters[a]) : "…"}–${filters[b] ? show(filters[b]) : "…"}`, { [a]: "", [b]: "" }]);
  });
  Object.entries(LISTS).forEach(([field, list]) => {
    const vals = filters[field] ? filters[field].split(",") : [];
    vals.forEach((v) => chips.push([`${field}-${v}`, labelOf(tx, list, v) || v, { [field]: vals.filter((x) => x !== v).join(",") }]));
  });
  if (filters.market) chips.push(["market", t(`enums.market.${filters.market}`), { market: "" }]);
  if (!chips.length) return null;
  return (
    <ul className="mt-4 flex flex-wrap gap-2" data-testid="filter-chips">
      {chips.map(([id, label, patch]) => (
        <li key={id}>
          <button type="button" onClick={() => update(patch)} data-testid={`chip-${id}`} aria-label={`${t("filters.remove")}: ${label}`}
            className="inline-flex min-h-[36px] items-center gap-2 border border-ink/20 bg-white px-3 text-[13px] transition-colors duration-300 hover:border-ink">
            {label} <X size={13} strokeWidth={1.5} />
          </button>
        </li>
      ))}
    </ul>
  );
};
